import {Window} from './Window.js';

/**
 * Called from code generated by AgendaTag to initialize chart selector
 * @param selectId id of a select tag
 */
export function hookChartSelector(selectId, agendaName) {
	$('#'+selectId).on('change', function(e) {
		displayChart($(this), agendaName);
	});
}

const winds = new Map();

function displayChart(select, agendaName) {
	const action = select.val();
	const opText = select.find("option:selected").text();
	if (action === '') return;
	select.val('');	// reset position

	let w = winds.get(action);
	let setPosition = false;
	if (!w) {
		w = new Window(opText, null, "chart-pie2");
		winds.set(action, w);
		setPosition = true;	// first time open
	}
	if (w.closed) {
		w.open(false);
		fetchChartFor(w, action, agendaName, setPosition);
	}
	w.focus();
}

let canvasId = 1;
/**
 * Get chart data from server
 * @param {Window} wind
 * @param {string} action
 */
function fetchChartFor(wind, action, agenda, setPosition) {

	const w = $(window).width();
	const h = $(window).height();

	$.getJSON("chart.do?action="+encodeURIComponent(action)+"&agenda="+encodeURIComponent(agenda)+"&sw="+w+"&sh="+h, function(data) {
		const b = wind.getBody();
		b.empty();
		if (data.screen) {
			let s = data.screen;
			if (s.width) b.css("width", s.width+"px");
			if (s.height) b.css("height", s.height+"px");
			if (setPosition) {
				if (s.x) wind.x = s.x;
				if (s.y) wind.y = s.y;
				wind.position();
			}
		}
		const id = "chart-canvas-"+(canvasId++);
		b.append("<canvas id='"+id+"'></canvas>");
		moment.locale(Server.lang);
		const ch = new Chart(id, data);
		wind.show();
	});
}
